module.exports = __webpack_public_path__ + "static/horsakova-675ffce22ece843b47e7d1ff5a89e9a1.jpg";